import { buildMainagentPath, MAINAGENT_ROUTE_BASE } from './mainagent-route';

export function getQuery(variable: string) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
const isDebugger = getQuery('debugger');

function withDebug(url: string) {
  return isDebugger ? url + '?debugger=1' : url;
}
export const getHomeUrl = (widthOrigin: boolean = true) => {
  return withDebug(widthOrigin ? location.origin : '/');
};
export const getHistoryUrl = (widthOrigin: boolean = true) => {
  const base = withDebug(
    widthOrigin ? location.origin + '/history' : '/history',
  );
  const launchOptions = encodeURIComponent(
    '{"webviewBgColor":"transparent","topBarPosition":"none","enableProgress":"false"}',
  );
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}layoutType=4&__launch_options__=${launchOptions}`;
};

/** 定时任务列表页完整链接（带 origin），参数与历史页保持一致 */
export const SCHEDULED_TASK_URL =
  typeof location !== 'undefined'
    ? (() => {
        const base = withDebug(location.origin + '/scheduled-task');
        const launchOptions = encodeURIComponent(
          '{"webviewBgColor":"transparent","topBarPosition":"none","enableProgress":"false"}',
        );
        const separator = base.includes('?') ? '&' : '?';
        return `${base}${separator}layoutType=4&__launch_options__=${launchOptions}`;
      })()
    : '';
export const getFilesUrl = (
  conversationId: string,
  widthOrigin: boolean = true,
) => {
  const base = withDebug(
    widthOrigin
      ? location.origin + '/files/' + conversationId
      : '/files/' + conversationId,
  );
  const launchOptions = encodeURIComponent(
    '{"webviewBgColor":"transparent","topBarPosition":"none","enableProgress":"false"}',
  );
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}layoutType=4&__launch_options__=${launchOptions}`;
};
export const getConversationDetailUrl = (
  conversationId: string,
  widthOrigin = true,
) => {
  return withDebug(
    widthOrigin
      ? location.origin + '/c/' + conversationId
      : '/c/' + conversationId,
  );
};

export const getClawSessionUrl = (sessionKey: string, widthOrigin = true) => {
  // 2026-04 起页面会话链接统一落在 /mainagent/:sessionKey。
  // 这里是前端页面地址，不影响仍沿用 /claw/api 的后端接口。
  // session key 格式为 agent:main:<uuid>，取最后一段作为 URL path segment
  const baseKey = sessionKey.split(':').pop() ?? sessionKey;
  return withDebug(
    widthOrigin
      ? `${location.origin}${buildMainagentPath(baseKey)}`
      : buildMainagentPath(baseKey),
  );
};

export const getClawUrl = (widthOrigin = true) => {
  return withDebug(
    widthOrigin
      ? `${location.origin}${MAINAGENT_ROUTE_BASE}`
      : MAINAGENT_ROUTE_BASE,
  );
};

export const getBaseKey = (sessionKey: string) =>
  sessionKey.split(':').pop() ?? sessionKey;

const SKILLS_ROUTE_PREFIX = '/skills';
const OFFICIAL_SKILLS_ROUTE_PREFIX = '/skills-official';

const SKILLS_OFFICIAL_ORIGIN_MAP = {
  TEST: 'https://kim-mario.staging.kuaishou.com',
  PRE: 'https://ee-mario.prt.kuaishou.com',
  PROD: 'https://mario.corp.kuaishou.com',
} as const;

function getSkillsOfficialOrigin(hostname: string) {
  if (hostname.endsWith('mario.corp.kuaishou.com')) {
    return SKILLS_OFFICIAL_ORIGIN_MAP.PROD;
  }

  if (hostname.endsWith('ee-mario.prt.kuaishou.com')) {
    return SKILLS_OFFICIAL_ORIGIN_MAP.PRE;
  }

  return SKILLS_OFFICIAL_ORIGIN_MAP.TEST;
}

function getSkillsOfficialPathname(pathname: string) {
  if (pathname === SKILLS_ROUTE_PREFIX) {
    return OFFICIAL_SKILLS_ROUTE_PREFIX;
  }

  const suffix = pathname.startsWith(`${SKILLS_ROUTE_PREFIX}/`)
    ? pathname.slice(SKILLS_ROUTE_PREFIX.length)
    : '';

  return `${OFFICIAL_SKILLS_ROUTE_PREFIX}${suffix}`;
}

export function getSkillsOfficialUrl(
  pathname: string = SKILLS_ROUTE_PREFIX,
  search = '',
  hash = '',
  hostname: string = location.hostname,
) {
  const url = new URL(getSkillsOfficialOrigin(hostname));
  url.pathname = getSkillsOfficialPathname(pathname);
  url.search = search;
  url.hash = hash;
  return url.toString();
}

export function shouldOpenSkillsInNewTabForLocal(
  hostname: string = location.hostname,
) {
  return process.env.NODE_ENV !== 'production' && hostname.startsWith('local.');
}

export const getPreviewUrl = (
  data: {
    blobKey: string;
    fileExtension: string;
    fileName: string;
    fileSize: string;
  },
  widthOrigin = true,
) => {
  const origin = widthOrigin ? location.origin : '';
  return (
    origin +
    '/preview?blobKey=' +
    data.blobKey +
    '&fileExtension=' +
    data.fileExtension +
    '&fileName=' +
    data.fileName +
    '&fileSize=' +
    data.fileSize
  );
};
